module.exports = __webpack_public_path__ + "static/img/Bachelor_010716.79da124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010716.jpg
// module id = 232
// module chunks = 0